/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailGearOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Email Gear Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.925 24.678H32.61a6.69 6.69 0 0 0-.977-2.373l1.648-1.648a.661.661 0 0 0 0-.935l-1-1a.661.661 0 0 0-.935 0L29.7 20.368a6.693 6.693 0 0 0-2.373-.978v-2.314a.661.661 0 0 0-.661-.661h-1.327a.661.661 0 0 0-.661.661v2.315a6.692 6.692 0 0 0-2.373.978l-1.648-1.649a.661.661 0 0 0-.935 0l-1 1a.661.661 0 0 0 0 .935l1.648 1.648a6.69 6.69 0 0 0-.977 2.373h-2.317a.661.661 0 0 0-.661.661v1.322a.661.661 0 0 0 .661.661h2.315a6.69 6.69 0 0 0 .977 2.373l-1.648 1.651a.661.661 0 0 0 0 .935l1 1a.661.661 0 0 0 .935 0l1.648-1.648a6.692 6.692 0 0 0 2.373.977v2.315a.661.661 0 0 0 .661.661h1.322a.661.661 0 0 0 .661-.661V32.61a6.693 6.693 0 0 0 2.373-.977l1.648 1.648a.661.661 0 0 0 .935 0l1-1a.661.661 0 0 0 0-.935L31.632 29.7a6.69 6.69 0 0 0 .977-2.373h2.315a.661.661 0 0 0 .661-.661v-1.327a.661.661 0 0 0-.66-.661ZM26 29.6a3.6 3.6 0 1 1 3.6-3.6 3.6 3.6 0 0 1-3.6 3.6Z"
    />
    <path
      d="M17.259 30H2v-2.392l11.165-8.358 3.635 2.725a1.973 1.973 0 0 0 .735.326l-.231-.231a2.638 2.638 0 0 1-.621-2.682L2 8.38V6h32v2.334l-8.08 6.081h.741a2.617 2.617 0 0 1 1.7.661L34 10.835v6.779l.7.7a2.665 2.665 0 0 1 0 3.762l-.607.607h.838a2.626 2.626 0 0 1 1.069.232V5.167A1.147 1.147 0 0 0 34.875 4H1.125A1.147 1.147 0 0 0 0 5.167v25.666A1.147 1.147 0 0 0 1.125 32h15.439a2.62 2.62 0 0 1 .695-2ZM2 10.881 11.5 18 2 25.107Z"
    />
  </svg>`;
};
